import { Flex, Spinner } from '@radix-ui/themes'
import { useNavigate } from '@tanstack/react-router'
import { TestManageItem } from '@/types/practice-test'
import { cn } from '@/lib/utils'
import {
  FormatFullDateMonthYearHourMinute,
  FormatFullDateTimeWithAMPM,
} from '@/utils/time'
import { Button } from '@/components/ui/button'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { TestTabs } from '../constants'

const DraftTable = ({
  tests,
  moduleId,
  isLoadingTests,
  testType,
}: {
  tests: TestManageItem[]
  moduleId: string
  isLoadingTests: boolean
  testType: string
}) => {
  const navigate = useNavigate()

  return (
    <Table>
      <TableHeader>
        <TableRow className='bg-[#F2F4F7]'>
          <TableHead className='font-mundial p-4 text-sm font-[600] text-[#002652]'>
            Name
          </TableHead>
          <TableHead className='font-mundial w-[140px] text-sm font-[600] text-[#002652]'>
            Updated At
          </TableHead>
          <TableHead className='font-mundial w-[140px] text-center text-sm font-[600] text-[#002652]'>
            Questions
          </TableHead>
          <TableHead className='font-mundial w-[140px] text-center text-sm font-[600] text-[#002652]'>
            Time
          </TableHead>
          <TableHead className='font-mundial w-[140px] text-center text-sm font-[600] text-[#002652]'>
            Mark Available
          </TableHead>
          <TableHead className='font-mundial max-w-[10%] text-center text-sm font-[600] text-[#002652]' />
        </TableRow>
      </TableHeader>
      <TableBody>
        {isLoadingTests ? (
          <TableRow>
            <TableCell colSpan={8}>
              <Flex justify={'center'}>
                <Spinner size={'3'} />
              </Flex>
            </TableCell>
          </TableRow>
        ) : (
          <>
            {tests?.length === 0 && (
              <TableRow>
                <TableCell colSpan={8} className='h-24 text-center'>
                  No data found.
                </TableCell>
              </TableRow>
            )}
            {tests?.map((item) => (
              <TableRow key={item.id} className='hover:bg-gray-50'>
                <TableCell className='w-[167px] truncate p-4'>
                  <div className='max-w-[230px] min-w-[230px] truncate text-sm font-[400] text-[#002652]'>
                    {item.name}
                    <div className='truncate text-sm font-[300] text-[#475467]'>
                      Created date:{' '}
                      {FormatFullDateMonthYearHourMinute(item.created_at)}
                    </div>
                  </div>
                </TableCell>
                <TableCell className='w-[15%] text-sm font-[300] text-[#002652]'>
                  {FormatFullDateTimeWithAMPM(item.updated_at)}
                </TableCell>
                <TableCell
                  className={cn(
                    'w-[15%] text-center text-sm font-[300] text-[#002652]'
                  )}
                >
                  {item.total_questions}
                </TableCell>
                <TableCell
                  className={cn(
                    'w-[15%] text-center text-sm font-[300] text-[#002652]'
                  )}
                >
                  {item.total_time} mins
                </TableCell>
                <TableCell
                  className={cn(
                    'w-[15%] text-center text-sm font-[300] text-[#002652]'
                  )}
                >
                  {item.total_marks}
                </TableCell>
                <TableCell className='w-[5%] pr-5 text-center'>
                  <Button
                    className='h-auto bg-transparent px-3 py-2 font-medium text-[#0057B8] shadow-none hover:bg-[#0057B8]/10 hover:text-blue-800'
                    onClick={() => {
                      navigate({
                        to:
                          testType === TestTabs.mock_exam
                            ? '/create-mock-exam/detail/$ptId/$moduleId'
                            : '/create-practice-test/detail/$ptId/$moduleId',
                        params: { ptId: item.id.toString(), moduleId },
                        search: {
                          source:
                            testType === TestTabs.mock_exam
                              ? 'ExamTable'
                              : 'TestTable',
                        },
                      })
                    }}
                  >
                    View detail
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </>
        )}
      </TableBody>
    </Table>
  )
}

export default DraftTable
